// extracted by mini-css-extract-plugin
export default {"number":"CompanyHotWalletsTableView_number__+ccOy","tableWrapper":"CompanyHotWalletsTableView_tableWrapper__2VslW","checkedStatus":"CompanyHotWalletsTableView_checkedStatus__ycCa0"};